import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import classNames from 'classnames';
import InteractionIcon from './InteractionIcon';

const InteractionTypeButtonGroup = ({ interactionTypes, value, onChange, intl }) => {
  const handleToggle = useCallback(
    e => {
      const interactionType = parseInt(e.currentTarget?.name ?? e.target.name);
      if (interactionType === null || Number.isNaN(interactionType)) return;

      const idx = value.indexOf(interactionType);
      document.activeElement.blur();
      if (idx >= 0) {
        onChange(value?.filter(x => x !== interactionType) ?? []);
      } else {
        onChange([...(value || []), interactionType]);
      }
    },
    [value, onChange],
  );

  return (
    <div
      role="group"
      aria-label="interactionType"
      className="btn-group"
      style={{ display: 'flex' }}
    >
      {interactionTypes.map(interactionType => {
        const label = intl.formatMessage(listItemMsg('interactiontype', interactionType));
        return (
          <button
            onClick={handleToggle}
            type="button"
            title={label}
            className={classNames('btn btn-default', {
              active: value && value.includes(interactionType),
            })}
            name={interactionType}
            key={interactionType}
            style={{ flex: 1 }}
          >
            <InteractionIcon intl={intl} type={interactionType} />
            <span className="margin5L">{label}</span>
          </button>
        );
      })}
    </div>
  );
};
InteractionTypeButtonGroup.propTypes = {
  interactionTypes: PropTypes.arrayOf(PropTypes.number),
};
InteractionTypeButtonGroup.defaultProps = {
  interactionTypes: [0, 3, 1, 2],
};

export default InteractionTypeButtonGroup;
